<template>
  <div class="addSampleList">
    <div v-if="currentPage!=='smsSending'" class="sample-title">{{ num ? num : '' }}选择样本</div>
    <el-radio-group v-if="isQY && currentPage === 'telephoneInterviewer' && showTaskType!=='edit'" v-model="callType" class="mb-3" @input="changeCallType">
      <el-radio :label="3" :disabled="activeCallType === 5">固定样本</el-radio>
      <el-radio :label="5" :disabled="activeCallType === 3">预测式外呼</el-radio>
    </el-radio-group>
    <div v-if="tableData.length === 0 && currentPage!=='smsSending' && callType !== 5" class="sample-body">
      <div class="sample-center-box">
        <p class="sample-no-text">暂无样本</p>
        <el-button type="primary" @click="addPhoneList">手机号添加</el-button>
        <el-button class="gost-btn" style="margin-left:16px" @click="addSample">从样本群组中选择</el-button>
      </div>
    </div>
    <div v-if="isQY && callType === 5 && showTaskType!=='edit'" class="px-4 py-3" style="background: #F5F5F5;">
      <span class="text-theme-black-850 text-medium">关联样本群组</span>
      <el-tooltip content="采用预测式外呼方式，将从关联的样本群组中智能为调查员分配样本坐席，可以解决大规模的外呼诉求，同时极大提升坐席利用率。" effect="light" placement="bottom">
        <span class="ml-1">
          <i class="iconfont icon-shuoming cursor-pointer text-medium text-theme-black-350"></i>
        </span>
      </el-tooltip>
      <el-select v-model="prediction.type" size="small"
        class="field-text-size field-text-spacing ml-3 bg-white-input" style="width: 128px" placeholder="群组类型"
        @change="changeConditionType">
        <el-option v-for="item of typeList.filter(it=>it.isShow)" :key="item.id" :label="item.label" :value="item.id" />
      </el-select>
      <el-select filterable v-model="prediction.group" size="small" class="field-text-size field-text-spacing bg-white-input"
        style="width: 330px;margin-left: 12px;margin-right: 12px" placeholder="请选择群组" @change="changeConditionGroup">
        <el-option v-for="item of groups" :key="item.id" :label="item.groupName" :value="item.id" :disabled="item.disabled" />
      </el-select>
    </div>
    <div v-else-if="tableData.length > 0" class="sample-list" :style=" `min-height: ${callType !== 5 || callType === 5 && showTaskType === 'edit'?'auto':'300px'};`">
      <div class="sample-list-header" v-if="callType !== 5 || callType === 5 && showTaskType === 'edit'">
        <div class="layout-left">
          <div class="sample-type style-text" v-if="isQY && callType === 5">预测式外呼</div>
          <div class="sample-type style-text" v-else-if="isQY && callType !== 5">固定样本</div>
          <div class="sample-type style-text">{{typeName}}</div>
          <div class="sample-group-name style-text">{{groupName}}</div>
          <el-button type="primary" @click="newAddSample" v-if="callType !== 5">追加样本</el-button>
        </div>
        <div class="layout-right" v-if="callType !== 5">
          <el-button v-if="currentPage!=='smsSending'&& group!== -1" @click="() => { 
            this.seetingFieldsVisible = true;
            this.checkBoxData = this.checkBoxData;
          }" type="text" :loading="checkedSeetingLoading">设置样本显示内容</el-button>
        </div>
      </div>
      <div class="sample-list-body" v-if="callType !== 5">
        <DataTable v-if="showOld" ref="crud" class="avue1" :page="page" :showPage="showPage" :data="tableData" :columns="columns"
          :selection="true" @selection-change="selectionChange" :loading="loading" rowKey="id" :isShowCheckCount="true"
          @size-change="sizeChange" @pagination-current-change="currentChange" :height="'45vh'">
          <template #opt="{ row }">
            <ClickDelete title="样本删除" @delFun="del(row)">
              <p slot="content">样本被删除后无法撤消，需要重新添加样本</p>
              <el-button type="text" size="small" slot="delBtn">删除</el-button>
            </ClickDelete>
          </template>
          <template slot="page-left">
            <div class="inline-block">
              <el-checkbox style="margin-right: 12px" @change="changeCheckbox" v-model="checked">选择全部</el-checkbox>
              <ClickDelete title="样本删除" @delFun="amoutDel">
                <p slot="content">样本被删除后无法撤消，需要重新添加样本</p>
                <el-button type="danger" plain slot="delBtn" class="ml-2.5">删除</el-button>
              </ClickDelete>
            </div>
          </template>
          <template slot="empty">
            <div>还未添加样本</div>
          </template>
        </DataTable>
        <template v-else>
          <el-table
            height="45vh"
            :data="tableData"
            :loading="loading"
            row-key="id"
            show-overflow-tooltip
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55" />
            <el-table-column
              v-for="item in columns"
              :key="item.value"
              :prop="item.value"
              :label="item.label">
              <template v-if="item.value==='opt'" #default="{row}">
                <el-button type="text" @click="onRemoveTableItem(row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="mt-4 text-small">
            <span>已选择 <span class="text-theme">{{selectionList.length}}</span> 项</span>
            <el-button type="danger" plain class="ml-2.5" @click="onRemoveAll">删除</el-button>
          </div>
        </template>
      </div>
    </div>
    <InitSample :visible="initSampleVisible" @handleClose="() => (this.initSampleVisible = false)"
      @handleRefresh="handleRefresh" />
    <SeetingFields :visible="seetingFieldsVisible" :checkedSeetingFields="checkedSeetingFields" @handleClose="handleCloseSeetingFields"
      :checkBoxData="checkBoxData" />
    <ChoseSample 
      :currentPage="currentPage"
      :type="type"
      :group="group"
      :tableDataIds="tableDataIds"
      :visible="choseSampleVisible" 
      @handleClose="() => (this.choseSampleVisible = false)"
      @handleSelectList ="getChoseSampleSelectList"
       />

    <el-dialog
      title="批量输入手机号添加样本"
      :visible.sync="dialogVisible"
      :before-close="phoneHandleClose"
      :append-to-body="true"
      top="0"
      width="766px"
      class="theme-dialog dialog-center dialog-body-0 split-line-footer-dialog"
    >
      <div class="pwd-notice px-6 bg-eee text-small leading-22 text-theme-black-650 py-1">
        <div>
          格式：<span class="text-theme-black-850 font-medium">调研员手机号</span> 或
          <span class="text-theme-black-850 font-medium">调研员手机号 + 逗号 + 调研员姓名</span>
        </div>
        <div>
          示例：<span class="text-theme-black-850 font-medium">15122223333</span> 或
          <span class="text-theme-black-850 font-medium">15122223333，张三</span> 
          <!-- 或 <span class="text-theme-black-850 font-medium">座机 010- 、 (010) 格式开头<span class="text-theme">【注：添加样本可填座机、添加调研员暂时不能】</span></span> -->
        </div>
      </div>
      <div v-show="errorMsgVisible"
        class="px-4 py-2 text-danger"
        style="background-color: rgb(252, 241, 240);">
        <span>错误信息（{{ errorType === '1' ? '姓名包含特殊字符【不能含有数字、字母、中文以外其他字符】' : '号码格式错误【手机号1开头且11位数字，座机需要10到12位纯数字】' }}）：</span><br />
        <div class="leading-tight inline-block" v-html="errMsgArr.join('<br />')"></div>
        <el-button type="text" @click="delErrorData">删除错误数据</el-button>
      </div>

      <div class="input-box p-6 pt-4">
        <el-input
          type="textarea"
          v-loading="inpLoading"
          :rows="15"
          resize="none"
          placeholder="一个调研员一行，例如：
15122223333
15122223333，张三
15888888888，李四
15999999999
0101234567,王五
01012345678,赵六
010123456789,沈七"
          v-model="inputValue"
        ></el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="inputCancel" size="mini">取 消</el-button>
        <el-button type="primary" @click="inputConfirm" size="mini">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import InitSample from '@/views/survey/offline/components/drawer/InitSample'
import SeetingFields from '@/views/survey/offline/components/drawer/SeetingFields'
import ChoseSample from '@/views/survey/offline/components/drawer/ChoseSample'
import DataTable from '@/components/base/DataTable'
import ClickDelete from '@/components/PopConfirm.vue'
import { getSampleAnsPage, hasSampleAns, wjsampleShowFields, getSampleHeader, getSampleAnsForSms, removeSampleAnsForSms,getOfflineSampleList } from '@/api/wenjuan/offline'
import GlobalConfig from '@/global/config'
import { guid } from '@/assets/js/utils'
import { isMobile, isLandline, isLandlineAli } from '@/assets/js/validate'
import { getSampleGroupInfoByGroupType } from '@/api/wenjuan/offline'
import { mapGetters } from 'vuex'
import {  getPredictCallStatus } from '@/api/wenjuan/telephone.js'


export default {
  name: 'AddSampleList',
  components: { InitSample, DataTable, ClickDelete, SeetingFields, ChoseSample },
  data() {
    return {
      typeName: '',//   群组类型名称
      groupName: '', // 群组名称
      tableDataIds:[], // 已经添加列表数据的Id集合
      type: 0,  // 传入给ChoseSample 组件的参数用来控制 是否禁用群组类型选择
      group:0,  // 传入给ChoseSample 组件的参数用来控制 是否禁用群组名称选择
      initSampleVisible: false,  // 无样本数据显示的弹窗
      seetingFieldsVisible: false, // 设置字段内容弹窗
      choseSampleVisible: false, // 选择样本弹窗
      columns: [
        { fixed: 'left', label: '姓名', value: 'name', width: 80 },
        { fixed: 'left', label: '手机号', value: 'phone', width: 150 },
        { fixed: false, label: '邮箱', value: 'email', width: 150 },
        { fixed: false, label: '性别', value: 'sex', width: 150 },
        { fixed: false, label: '出生日期', value: 'birthday', width: 150 },
        { fixed: false, label: '年龄区间', value: 'ages', width: 150 },
        { fixed: false, label: '居住地', value: 'address', width: 150 },
        { label: '操作', value: 'opt', width: 100, fixed: 'right' }
      ],
      tableData: [
        // { id: "1", name: '张三1', phone: '18630962742', email: 'wxc@qq.com', sex: '男', birthday: '2022-11-10', ages: '20~40岁', address: "天津市河东区" },
        // { id: "2", name: '张三2', phone: '18630962742', email: 'wxc@qq.com', sex: '男', birthday: '2022-11-10', ages: '20~40岁', address: "天津市河东区" },
        // { id: "3", name: '张三3', phone: '18630962742', email: 'wxc@qq.com', sex: '男', birthday: '2022-11-10', ages: '20~40岁', address: "天津市河东区" },
        // { id: "4", name: '张三4', phone: '18630962742', email: 'wxc@qq.com', sex: '男', birthday: '2022-11-10', ages: '20~40岁', address: "天津市河东区" },
        // { id: "5", name: '张三5', phone: '18630962742', email: 'wxc@qq.com', sex: '男', birthday: '2022-11-10', ages: '20~40岁', address: "天津市河东区" },
        // { id: "6", name: '张三6', phone: '18630962742', email: 'wxc@qq.com', sex: '男', birthday: '2022-11-10', ages: '20~40岁', address: "天津市河东区" },
        // { id: "7", name: '张三7', phone: '18630962742', email: 'wxc@qq.com', sex: '男', birthday: '2022-11-10', ages: '20~40岁', address: "天津市河东区" },
      ],
      selectionList: [],
      page: {
        current: 1,
        pageSizes: [10, 20, 30, 40, 50],
        size: 10,
        total: 7
      },
      showPage: false,
      loading: false,
      checked: false,
      checkedSeetingFields: [],
      // 传入设置字段内容弹窗的字段集合数据
      checkBoxData: [
        // { label: '姓名', value: 'name', disabled: true },
        // { label: '手机号', value: 'phone', disabled: true },
        // { label: '邮箱', value: 'email' },
        // { label: '出入日期', value: 'birthday' },
        // { label: '性别', value: 'sex' },
      ],
      dialogVisible:false,
      inpLoading: false,
      inputValue:'',
      phoneColumns:[
        { fixed: 'left', label: '姓名', value: 'name', width: 80 },
        { label: '手机号', value: 'phone', width: 150 },
        { label: '操作', value: 'opt', width: 100, fixed: 'right' }
      ],
      errorMsgVisible: false, // 错误提示
      errMsgArr: [], // 错误信息
      errorType: '', // '1' 电话姓名格式错误； '2' 电话错误
      commaReg: /[,|，]+/g, // 逗号查找
      nameCheckReg: /^[\w|\u4e00-\u9fa5|`|\-|=|\[|\]|;|'|\\|.|/|*|~|!|@|#|$|%|^|&|*|(|)|+|{|}|:|"|\||<|>|?|·|【|】|；|‘|。|、|~|！|@|#|￥|%|……|&|*|（|）|——|：|“|”|《|》|？]*$/, // 姓名验证正则,
      callType: 3,
      prediction: {},
      typeList: [
        { id: 1, label: '手机群组',isShow:true },
        { id: 2, label: '邮箱群组',isShow: ['telephoneInterviewer','smsSending'].includes(this.currentPage) ? false : true },
        { id: 3, label: '点位群组',isShow: ['telephoneInterviewer','smsSending'].includes(this.currentPage) ? false : true },
      ],
      groups: [],
      predictCallGroupId: null,
      checkedSeetingLoading: false
    }
  },
  inject:['addSampleType'],
  props: {
    num: {
      type: String,
      default: ''
    },
    currentPage: {
      type: String,
      default: ''
    },
    sampleDetails: {
      type: Object,
      default: () => ({
        tableData: [],
      })
    },
    isHaveTask: {
      type: Boolean,
      default: false
    },
    activeCallType: {
      type: [String, Number],
      default: null
    },
    showTaskType:{
      type: String,
      default: ''
    },
    jobForm: {
      type: [String, Number],
      default: null
    },
  },
  watch: {
    tableData: {
      handler(val) {
        if (val.length === 0) {
          this.type = 0;
          this.tableDataIds = [];
        }else{
          this.tableDataIds = val.map(it=> (it.id));
          this.$emit('selectionChangeEmit',val, this.type, this.group, this.groupName, this.checkedSeetingFields, this.checkBoxData);
        }
      },
      deep: true,
    },
    checkBoxData: {
      handler(val) {
        if (val.length === 0) {
          // this.type = 0;
        }else{
          this.$emit('selectionChangeEmit',this.tableData, this.type, this.group, this.groupName, this.checkedSeetingFields, val);
        }
      },
      deep: true,
    },
    sampleDetails: {
      handler(val) {
        if (val.tableData.length > 0) {
          this.getInitTableData()
        }
      },
      deep: true,
    },

  },
  methods: {
    handleClose() {
      this.$emit('handleClose', false);
    },
    // 添加样本按钮
    addSample() {

      hasSampleAns().then(res=> {
        if(res.data.code === 0){
          if(res.data.data === true){
            this.choseSampleVisible = true;
          } else {
            this.initSampleVisible = true;
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
      // this.initSampleVisible = true;
      // this.choseSampleVisible = true;
    },
    // 追加样本
    newAddSample(){
      if(this.group === -1){
        this.dialogVisible = true;
      }else{
        this.choseSampleVisible = true;
      }
    },
    // 分页切换查询方法
    currentChange(val) {
      this.page.current = val;
      // this.getTableList();
      if(this.currentPage === 'smsSending'){
        this.getSmsSendTableData();
      }
    },
    // 切换分页器
    sizeChange(val) {
      this.page.size = val;
      // this.getTableList();
      if(this.currentPage === 'smsSending'){
        this.getSmsSendTableData();
      }
    },
    // 勾选的数据
    selectionChange(list) {
      this.selectionList = list;
      this.checked = list.length === this.tableData.length;
    },
    // 短信页面删除勾选样本
    removeSmsSendTableData(sampleAnsIds){
      removeSampleAnsForSms({
        sampleAnsIds,
        surveyId: GlobalConfig.getSurveyId(),
      }).then(res=> {
        if(res.data.code === 0){
          this.$message.success('删除成功');
          this.$refs.crud.clearSelection();
          this.getSmsSendTableData();
        }
      })
    },
    // 删除当前数据
    del(row) {
      // 调用短信样本删除接口
      if(this.currentPage === 'smsSending'){
        // this.getSmsSendTableData(selectList, checkAll, type, group, columns, groupName);
        this.removeSmsSendTableData([row.id])
        return ;
      }
      console.log('row', row)
      this.tableData = this.tableData.filter(it => it.id !== row.id);
      this.$refs.crud.clearSelection();
      this.$message.success('删除成功');
    },
    // 全部选择切换
    changeCheckbox(val) {
      if (val) {
        this.$refs.crud.toggleAllSelection()
      } else {
        this.$refs.crud.clearSelection()
      }
    },
    // 批量删除
    amoutDel() {
      if (this.selectionList instanceof Array && this.selectionList.length > 0) {
        // 调用短信样本删除接口
      if(this.currentPage === 'smsSending'){
        // this.getSmsSendTableData(selectList, checkAll, type, group, columns, groupName);
        this.removeSmsSendTableData(this.selectionList.map(it=> (it.id)))
        return ;
      }
        const ids = this.selectionList.map(it => (it.id))
        this.tableData = this.tableData.filter(it => !ids.includes(it.id));
        this.$refs.crud.clearSelection()
        this.$message.success('删除成功');
      } else {
        this.$message.warning('请选择要删除的数据');
      }
    },
    // 子组件刷新回调
    handleRefresh(val) {
      // 判断当前返回值如果为true 则跳转样本库选择弹窗并关闭InitSample弹窗
      if (val) {
        this.initSampleVisible = false;
      }
    },
    // 获取设置字段弹窗勾选数据
    handleCloseSeetingFields(flag, postData) {
      console.log('flag,postData', flag, postData)
      this.seetingFieldsVisible = flag;
      if(postData){
        this.checkedSeetingFields = postData;
      }
    },
    // 获取全量列表数据
    getTableData(groupId, params = { conditionRule:2, ruleGroups:[] ,rules:[] }) {
      getSampleAnsPage({
        groupId,
        conditionRule: params.conditionRule,
        ruleGroups: params.ruleGroups,
        rules: params.rules
      }).then(res => {
        if (res.data.code === 0) {
          this.tableData = res.data.data.records;
          this.page.total = res.data.data.records.length;
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 获取短信样本数据
    getSmsSendTableData () {
      getSampleAnsForSms({
        current: this.page.current,
        size: this.page.size,
        surveyId: GlobalConfig.getSurveyId(),
      }).then(res => {
        if(res.data.code === 0){
          console.log('res.data.data',res.data.data)
          this.showPage = true;
          if(res.data.data.tableData){
            this.tableData = res.data.data.tableData.records;
            this.page = {
              ...this.page,
              total: res.data.data.tableData.total,
              current: res.data.data.tableData.current,
              size: res.data.data.tableData.size,
            }
            this.$emit('smsSendTableSuccess', res.data.data.tableData);
          }else{
            this.$emit('smsSendCallBack');
            this.tableData = [];
          }
          this.type = res.data.data.type;
          this.group = res.data.data.group;
          this.groupName = res.data.data.groupName;
          this.setTypeName(res.data.data.groupName.type)
        }
      })
    },
    // 获取动态列
    // 获取筛选字段集合
    getCheckBoxData(group, id=''){
     return wjsampleShowFields({
        groupId:group,
        taskId:id
      }).then(res=> {
        if(res.data.code === 0){
          this.checkBoxData = res.data.data;
          this.checkedSeetingFields = res.data.data.filter(it=>it.disabled).map(it=> (it.value))
          // this.checkedSeetingFields = [...new Set(
          //   [
          //     ...res.data.data.filter(it=>it.disabled).map(it=> (it.value)),
          //     ...this.checkedSeetingFields
          //   ]
          // )];
        }
      })
    },
    
    // 获取添加样本弹窗选中的样本数据
    /**
     * 
     * @param { Array }   selectList 勾选的数据
     * @param { Boolean } checkAll   是否勾选全部数据
     * @param { String }  type       选中的群组
     * @param { String }  group      选中的样本分类
     * @param { Array }   columns    表格的动态列
     * @param { String }  groupName  群组名称
     * @param { String }  groupName  群组名称
     * @param { Object }  conditions 高级筛选参数
     */
    getChoseSampleSelectList(selectList, checkAll, type, group, columns, groupName, conditions){
      const isNew = !this.tableData.length
      this.choseSampleVisible = false;
      this.checked = false;
      this.columns = [ ...columns, { label: '操作', value: 'opt', width: 100, fixed: 'right' }]
      this.groupName = groupName;
      this.setTypeName(type)
      // 当前页面如果为短信发送页则直接调用接口查询列表数据 
      if(this.currentPage === 'smsSending'){
        if(this.type !== type){
          this.type = type;
          this.group = group
        }
        this.getSmsSendTableData();
        return ;
      } else{
        if(this.type !== type){
          this.getCheckBoxData(group).then(()=>{      
            if (isNew && this.addSampleType === 'offline') {
              this.checkedSeetingLoading = true
              getOfflineSampleList({
                surveyId: GlobalConfig.getSurveyId(),
                size:999,
                current: 1,
                id: this.$route.query.id
              }).then(res=>{
                const records = res.data.data.records
                for (let index = records.length-1; index >=0; index--) {
                  const record = records[index];  
                  if (record.sampleDetails.group === group) {
                    this.checkedSeetingFields = record.sampleDetails.checkedSeetingFields
                    break
                  }
                }
              }).finally(()=>{
                 this.checkedSeetingLoading = false
              })
            }
          })
        }
      }
      // 判断当前页面中的群组与弹窗中选中的群组是否一致
      // 一致则进行数据合并否则只是添加最新勾选数据
      if(checkAll === false){
        if(this.type === type){
          const repeatTableData = [...this.tableData,...JSON.parse(JSON.stringify(selectList))]
          let map = new Map();
          for (let item of repeatTableData) {
              if (!map.has(item.id)) {
                  map.set(item.id, item);
              };
          };
          // 合并去重后的数据
          let concatDataArr = [...map.values()];
          this.tableData = concatDataArr;
          this.page.total = concatDataArr.length;
        }else{
          this.type = type;
          this.group = group
          this.tableData = JSON.parse(JSON.stringify(selectList));
          this.page.total = this.tableData.length;
        }
      } else{
        if(this.type !== type){
          this.type = type;
          this.group = group
        }
        // 根据参数获取全部样本列表数据
        this.getTableData(group,conditions)
      }
    },
    getColumns(groupId) {
      console.log('groupId', groupId)
      return getSampleHeader({
        groupId
      }).then(res => {
        if (res.data.code === 0) {
          const columns = res.data.data.map(
            (item,idx)=> (
              { 
                label: item.name,
                value: String(item.index),
                width: 150,
                fixed: idx <= 1 ?'left' : false
              }
            ));
            this.columns = [...columns, { label: '操作', value: 'opt', width: 100, fixed: 'right' }]
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 获取详情数据
    getInitTableData(){
      if(this.sampleDetails && this.sampleDetails.tableData.length > 0) {
        console.log('获取详情数据')
        console.log('this.sampleDetails.group', this.sampleDetails.group)
        this.getColumns(this.sampleDetails.group)
        .then(()=> {
          this.tableData = this.sampleDetails.tableData;
          this.tableDataIds = this.sampleDetails.tableData.map(it=> (it.id));
          this.type = this.sampleDetails.type;
          this.group = this.sampleDetails.group;
          this.groupName = this.sampleDetails.groupName;
          // this.checkBoxData = this.sampleDetails.checkBoxData;
          if(this.sampleDetails.group === -1){
            this.columns = this.phoneColumns
          }else{
            this.getCheckBoxData(
              this.sampleDetails.group, this.sampleDetails.id
            ).then(()=> {
              this.checkedSeetingFields = [...new Set([...this.checkedSeetingFields,...this.sampleDetails.checkedSeetingFields])] 
            })
          }
          if(this.currentPage === 'smsSending'){
            this.showPage = true;
            this.page = {
              ...this.page,
              ...this.sampleDetails.page
            }
          }
          this.setTypeName(this.sampleDetails.type)
        })
      }
    },
    setTypeName(type){
      switch (type) {
        case 1:
          this.typeName = '手机群组'
          break;
        case 2:
          this.typeName = '邮箱群组'
          break;
        case 3:
          this.typeName = '点位群组'
          break;
        default:
          break;
      }
    },
    phoneHandleClose(){
      this.$confirm('确认关闭？')
        .then(_ => {
          this.inputValue = ''
          this.dialogVisible = false;
          done()
        })
        .catch(_ => {})
    },
    inputCancel() {
      this.dialogVisible = false
      this.inputValue = ''
    },
    addPhoneList(){
      this.dialogVisible = true;
    },
    inputConfirm() {
      this.inpLoading = true
      // const phoneReg =/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      //输入手机号 自动去后台匹配姓名及其他信息 如果没有 则自动创建
      if (this.inputValue.length > 0) {
        let inputVal = this.inputValue
        let arr = inputVal.split('\n').filter(Boolean) //去掉空行
        // 2. 逗号分组
        const commaReg = this.commaReg
        // 2-1. 手机/座机格式错误数组
        const isPhoneErrArr = arr.filter(item => {
          const phone = item.split(commaReg).filter(Boolean)[0]?.trim() ?? ''
          return !isMobile(phone) && !isLandlineAli(phone)
        })
        if (isPhoneErrArr.length > 0) {
          this.inpLoading = false
          this.errorMsgVisible = true // 错误提示
          this.errMsgArr = isPhoneErrArr // 错误数据
          this.errorType = '2'
          // this.$message.warning('当前输入的手机号格式错误，以1开发头11位数字')
          return
        } else {
          this.errorMsgVisible = false // 错误提示
          this.errMsgArr = [] // 错误数据
        }

        // 2-2. 姓名(不一定输入) 格式错误数组
        const errNameArr = arr.filter(item => {
          const name = item.split(commaReg).filter(Boolean)[1]?.trim() ?? ''
          return !this.nameCheckReg.test(name.replace(/ /g,''))
        })
        if (errNameArr.length > 0) {
          this.inpLoading = false
          this.errorMsgVisible = true // 错误提示
          this.errMsgArr = errNameArr // 错误数据
          this.errorType = '1'
          // this.$message.warning('输入格式有误，姓名可以是中文和大小写字母')
          return
        } else {
          this.errorMsgVisible = false // 错误提示
          this.errMsgArr = [] // 错误数据
        }
        arr = arr.map(item => {
          item = item.split(commaReg).filter(Boolean)
          return { phone: item[0]?.trim(), name: item[1]?.trim() ?? '' }
        })
        console.log('arr',arr)
        this.inpLoading = false
        this.dialogVisible = false
        this.inputValue = ''
        this.columns = this.phoneColumns;
        const tableData = arr.map((it)=> ({...it, name: it.name || '-', id: guid()}));
        this.tableData = [...this.tableData,...tableData]
        this.group = -1;
        this.type = 1
        this.setTypeName(1);
        this.groupName = '默认群组'
        this.checkedSeetingFields = ["name", "phone"];
        this.checkBoxData = [
          {"label":"姓名:","value":"name","disabled":true},
          {"label":"手机号:","value":"phone","disabled":true}
        ];
      } else {
        this.$message.warning('当前未输入手机号')
        this.inpLoading = false
        this.dialogVisible = false
        this.inputValue = ''
      }
    },
    delErrorData() {
      if (this.inputValue.length > 0) {
        let inputVal = this.inputValue
        let arr = inputVal.split('\n').filter(Boolean) //去掉空行
        if(this.errorType === '1') { // 手机号、姓名格式错误
          const commaReg = this.commaReg
          const successArr = arr.filter(item => {
            const name = item.split(commaReg).filter(Boolean)[1]?.trim() ?? ''
            return this.nameCheckReg.test(name.replace(/ /g,''))
          })
          this.inputValue = successArr.join('\n')
        }
        if(this.errorType === '2') { // 手机号格式错误
          const isPhoneSuccessArr = arr.filter(item => {
            const phone = item.split(this.commaReg).filter(Boolean)[0]?.trim() || ''
            return isMobile(phone) || isLandlineAli(phone)
          })
          this.inputValue = isPhoneSuccessArr.join('\n')
        }
      }
      this.errorMsgVisible = false
    },
    onRemoveTableItem(row){
      this.$confirm('样本被删除后无法撤消，需要重新添加样本?', '样本删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        this.del(row)
      })
    },
    onRemoveAll(){
      this.$confirm('样本被删除后无法撤消，需要重新添加样本?', '样本删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
       this.amoutDel()
      })
    },
    changeConditionType(val) {
      this.prediction.group = "";
      this.type = val;
      this.setTypeName(val)
      getSampleGroupInfoByGroupType({
        groupType: val
      }).then(res => {
        if (res.data.code === 0) {
          this.groups = res.data.data.map(item => ({
            ...item,
            disabled: this.predictCallGroupId ? item.id !== this.predictCallGroupId : false
          }));
        }
      })
      // this.list = [];
      // 重置高级筛选选项
      // this.conditions = {
      //   conditionRule: 2,
      //   ruleGroups:[],
      //   rules: []
      // };
      // this.list.length > 0 && this.clearSelection();
    },
    changeConditionGroup(val) {
      this.group = val;
      this.groupName = this.groups.find(it=> it.id === val).groupName || ''; 
      if(this.activeCallType === 5 && this.isHaveTask) return //如果添加预测式外呼任务且已经有过预测式外呼任务 跳过读取样本数据，避免大样本群组拖累页面速度
      this.getTableData(val);
    },
    changeCallType() {
      this.tableData = [];
      this.page.total = 0;
      this.prediction.type = "";
      this.prediction.group = "";
    },
    getPredictCallGroupId() {
      getPredictCallStatus({surveyId: GlobalConfig.getSurveyId()}).then(res=> {
        this.predictCallGroupId = res.data.data?.groupId??null
      }).catch(err => {
        this.$message.error(err.message)
      })
    }
  },
  created(){
    this.getInitTableData();
    console.log('this.showTaskType', this.showTaskType)
    if(this.showTaskType === 'edit') {
      this.callType = this.jobForm
    }else {
      this.callType = this?.activeCallType??3
    }
    if(this.callType === 5) {
      this.getPredictCallGroupId()
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    showOld() {
      // TODO
      return !(['wqOjYpIN','ceIpAFpK'].includes(GlobalConfig.getSurveyId()))
    },
    isQY() {
      return this.userInfo.isQY
    }
  }
}
</script>
<style lang="scss" scoped>
.addSampleList {
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;

  .sample-title {
    height: 22px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    letter-spacing: 0;
    line-height: 22px;
    margin-bottom: 16px;
  }

  .sample-list {
    width: 100%;
    .sample-list-header {
      height: 32px;
      margin-bottom: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .layout-left {
        display: flex;
        align-items: center;

        .sample-type::after {
          content: '|';
          color: rgba(0, 0, 0, 0.5);
          margin: 0 16px;
        }

        .sample-group-name {
          max-width: 490px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          margin-right: 12px;
        }

        .style-text {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.85);
        }
      }
    }
  }

  .sample-body {
    width: 100%;
    height: 300px;
    background-color: #F5F5F5;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;

    .sample-center-box {
      text-align: center;

      .sample-no-text {
        height: 22px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        line-height: 22px;
        margin-bottom: 24px;
      }
      .gost-btn:focus{
        color: #2775E8;
        border-color:#2775E8;
      }
      .gost-btn:hover{
        color: #7dacf1 !important;
        border-color: #7dacf1 !important;
      }
    }
  }
}
</style>